import type { MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brandAssets";
import { cn } from "@shared/lib/utils";

type BrandWordmarkProps = {
  className?: string;
  imgClassName?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  /** Droploud-style mark punctuation — a 6px accent square at the wordmark baseline (top bar only). */
  withTick?: boolean;
  /** Forwarded to the underlying Link — pass -1 to pull it out of the tab
   *  order while a hidden ancestor (e.g. the closed mobile drawer) still
   *  renders it in the DOM. */
  tabIndex?: number;
};

/** TYCOONEX wordmark — links to the Home hub (/home); shared by sidebar, top bar and drawer. */
export function BrandWordmark({
  className,
  imgClassName,
  onClick,
  withTick,
  tabIndex,
}: BrandWordmarkProps) {
  return (
    <Link
      to="/home"
      aria-label="TycoonEX home"
      onClick={onClick}
      tabIndex={tabIndex}
      className={cn(
        "inline-flex items-center rounded-sm outline-none focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-accent/60",
        className,
      )}
    >
      <img
        src={BRAND.tycoonWordmarkHeader}
        alt="TYCOONEX"
        className={cn("h-6 w-auto max-w-[8.5rem] object-contain object-left", imgClassName)}
        width={336}
        height={82}
        decoding="async"
      />
      {withTick ? (
        <span aria-hidden className="mb-[3px] ml-1.5 size-1.5 self-end rounded-[1px] bg-accent" />
      ) : null}
    </Link>
  );
}
